import React from 'react';
import { Badge, Box, Image, Flex, Text } from '@mantine/core';
import PropTypes from 'prop-types';

import { formatCurrency } from 'helpers/format.cuboh';
import { useMenuPreview } from 'hooks/useMenuManagementMenuPreview';
import { renderClassificationIcons } from 'helpers/menuManagement';
import { MENU_TYPES } from 'constants/menuManagement';

export default function MainItem({ mainItem, isMobile }) {
  const { menu, setAddMainItem } = useMenuPreview();
  const item = menu.items[mainItem];

  const classificationLabel = renderClassificationIcons(item?.classifications);
  const hasClassificationLabel = classificationLabel && classificationLabel !== 'Class: none';
  const isCateringMenu = menu?.menuType === MENU_TYPES.CATERING;

  const servingsTag = isCateringMenu ? item?.servingsTag : null;
  const servingsLabel = servingsTag ? `Serves ${servingsTag}` : null;

  const onCardClick = () => {
    setAddMainItem(mainItem);
  };

  const imageSize = isMobile ? 104 : 120;

  const menuImage = item.imageUrl ? (
    <Image
      src={item.imageUrl}
      alt={item.name}
      height={imageSize}
      width={imageSize}
      fit="cover"
      style={{
        borderRadius: 'var(--mantine-radius-sm)',
        objectFit: 'cover',
        width: `${imageSize}px`,
        flexShrink: 0,
      }}
    />
  ) : null;

  return (
    <Flex
      onClick={onCardClick}
      py={isMobile ? 'xs' : 'md'}
      gap="xs"
      align="center"
      h="100%"
      style={{ cursor: 'pointer' }}
    >
      <Flex
        direction="column"
        justify="space-between"
        style={{ flex: 1, minWidth: 0 }}
        h="100%"
      >
        <Box>
          <Text variant="title-sm" lineClamp={1}>
            {item.name}
          </Text>
          <Text
            variant="body-sm"
            mt="xs"
            lineClamp={2}
            style={{ wordBreak: 'break-word' }}
          >
            {item.description}
          </Text>
        </Box>
        <Flex justify="space-between" align="center" gap="xs3">
          <Text variant="sublabel-sm">
            {formatCurrency(item?.price?.price ? item.price.price / 100 : 0)}
          </Text>
          {(servingsLabel || hasClassificationLabel) && (
            <Flex gap="xs3" align="center" style={{ overflow: 'hidden', flexShrink: 1 }}>
              {servingsLabel && (
                <Badge variant="outline" size="xs" style={{ flexShrink: 0 }}>{servingsLabel}</Badge>
              )}
              {hasClassificationLabel && (
                <Badge
                  variant="outline"
                  size="xs"
                  style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    flexShrink: 1,
                  }}
                >
                  {classificationLabel}
                </Badge>
              )}
            </Flex>
          )}
        </Flex>
      </Flex>
      {menuImage}
    </Flex>
  );
}

MainItem.propTypes = {
  mainItem: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
};
